import { useState } from "react";
import { Pressable, Text, View } from "react-native";
import { Dialog, DialogHeader, haptic, IconButton } from "@louise/moon-ui";
import {
  useLocale,
  useTranslations,
  SUPPORTED_LOCALES,
  type Locale,
} from "@src/packages/i18n";
import { EMBER } from "../../onboarding/theme";

import {
  pressLabel,
  usePressCapture,
} from "@src/packages/analytics/usePressCapture";
import { semanticColors } from "@louise/theme/tokens";
const FLAGS: Record<Locale, string> = {
  en: "\u{1F1FA}\u{1F1F8}",
  fr: "\u{1F1EB}\u{1F1F7}",
};

const LABEL_KEYS: Record<Locale, string> = {
  en: "language_switcher.english",
  fr: "language_switcher.french",
};

export default function LanguageButton() {
  const capturePress = usePressCapture("LanguageButton");
  const { locale, setLocale } = useLocale();
  const t = useTranslations();
  const [open, setOpen] = useState(false);

  return (
    <>
      <IconButton
        onPress={() => {
          haptic("light");
          setOpen(true);
        }}
        hitSlop={8}
        size={36}
        accessibilityLabel={t("language_switcher.language")}
      >
        <Text style={{ fontSize: 20 }}>{FLAGS[locale]}</Text>
      </IconButton>

      <Dialog
        visible={open}
        onClose={() => setOpen(false)}
        closeButton="minimal"
        closeAccessibilityLabel={t("language_switcher.close_language_list")}
        closeAction="close_language_switcher"
        backdropPressLabel="dismiss_language_switcher"
      >
        <DialogHeader
          title={t("language_switcher.language")}
          style={{ marginBottom: 12 }}
        />
        <View style={{ gap: 4 }}>
          {SUPPORTED_LOCALES.map((lng) => {
            const selected = lng === locale;
            return (
              <Pressable
                key={lng}
                accessibilityRole="button"
                accessibilityState={{ selected }}
                onPress={() => {
                  capturePress(pressLabel(t(LABEL_KEYS[lng])), "set_locale");
                  haptic("selection");
                  void setLocale(lng);
                  setOpen(false);
                }}
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 12,
                  paddingHorizontal: 12,
                  paddingVertical: 12,
                  borderRadius: 12,
                  backgroundColor: selected
                    ? semanticColors.accent.tint
                    : "transparent",
                }}
              >
                <Text style={{ fontSize: 20 }}>{FLAGS[lng]}</Text>
                <Text
                  className="font-dm-sans"
                  style={{
                    fontSize: 15,
                    fontWeight: selected ? "600" : "400",
                    color: selected ? EMBER.colors.text : EMBER.colors.textMid,
                  }}
                >
                  {t(LABEL_KEYS[lng])}
                </Text>
              </Pressable>
            );
          })}
        </View>
      </Dialog>
    </>
  );
}
